'use strict';
import SessionStore from '../../services/session/SessionStore'
import * as mobx from 'mobx'

angular.module('clientDashboardApp').factory('userService', function ($q, $http, $rootScope) {


  function UserService() {
    this.orderedUserTypes = ["Standard", "LocationAdmin", "AccountAdmin", "ResellerAdmin", "ChatmeterAdmin"];
  }


  UserService.prototype.currentUser = function (refresh) {
    return $q.resolve(null) // wrap in angular promise for digest cycle to work like a champ
      .then(() => SessionStore.onceLoaded().then(() => mobx.toJS(SessionStore.user)))
  };

  UserService.prototype.getCurrentUser = function() {
    return mobx.toJS(SessionStore.user)
  }

  UserService.prototype.userLevel = function (userType) {
    return this.orderedUserTypes.indexOf(userType) || 0;
  }

  UserService.prototype.userTypeDifference = function (loggedInUserType,userTypeToCompare) {
    return this.userLevel(userTypeToCompare) - this.userLevel(loggedInUserType);
  }

  UserService.prototype.hasAccessToUser = function (loggedInUserType, userTypeToCompare, allowableDifference) {
    return this.userTypeDifference(loggedInUserType, userTypeToCompare) <= allowableDifference;
  }

  UserService.prototype.cacheResultUntilLoggedOut = function(getPromise) {

    const envelope = {}
    const settingCache = () => {
      const p = getPromise()
      if (!p || !p.then) {
        throw Error("getPromise fn parameter of UserService.cacheResultsUntilLoggedOut should return a promise")
      }
      envelope.get = () => p
      p.then(x => {
        envelope.get = () => Promise.resolve(x);
        $rootScope.$on('user:logout', () => {
          envelope.get = settingCache
        });
      }).catch(ex => {
        envelope.get = settingCache;
      });
      return p
    }
    envelope.get = settingCache

    return envelope
  }


  var userService = new UserService();
  return userService;
});
